import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

// Component
import DynamicTable from '../../components/DynamicTable';

// Images
import eye from '../../../sass/images/ver-ocultar.svg';
import searchIcon from '../../../sass/images/icons/search.svg';

export default function VehiclesTable({ vehicles, loading, onSelect, titleTranslate }) {
    const [search, setSearch] = useState('');

    const filteredVehicles = useMemo(() => {
        if (!search.trim()) return vehicles;
        const term = search.toLowerCase();
        return vehicles.filter((v) => v.licenseplate && v.licenseplate.toLowerCase().includes(term));
    }, [vehicles, search]);

    const columns = [
        {
            title: 'vehiclesTrips.plate',
            dataIndex: 'licenseplate',
            key: 'id',
        },
        {
            title: 'vehiclesTrips.action',
            key: 'action',
            render: (vehicle) => {
                if (!vehicle || !vehicle.id) return null;

                return (
                    <button type="button" onClick={() =>
                        onSelect({
                            id: vehicle.id,
                            plate: vehicle.licenseplate,
                        })
                    }>
                        <img src={eye} alt="Ver información" />
                    </button>
                );
            },
        },
    ];

    return (
        <>
            <div className="convention-services flex">
                <div className="modal-display company-content row-states">
                    <input
                        id='search_plate'
                        className="input_search form-control"
                        placeholder={titleTranslate('vehiclesTrips.search_plate')}
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button type="button">
                        <img src={searchIcon} alt={titleTranslate('alt:search')} />
                    </button>
                </div>
            </div>
            <DynamicTable
                data={filteredVehicles}
                columns={columns}
                loading={loading}
                rowKey="id_vehicle_api"
                titleTranslate={titleTranslate}
            />
        </>
    );
}


VehiclesTable.propTypes = {
    vehicles: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
};